module.exports = __webpack_public_path__ + "img/img.cedd5009.png";